import {
    createChainableTypeChecker,
    PropTypeError,
} from "data/util/typeHelpers";
import { uniqueId } from "underscore";

// so we can interleave!
const next = () => uniqueId("c");

/*
 * I provide a source of client-side IDs, distinct from server-generated IDs,
 * and a test for differentiating between them. Currently I piggy-back atop
 * Backbone to avoid conflicts while we're still assuming Backbone "stuff" both
 * client- and server-side. Eventually that restriction can lift and the
 * generation made more efficient (and safer), if it's useful.
 */
const ClientId = {
    next,

    is(id) {
        const sid = id.toString();
        if (sid.charAt(0) !== "c") {
            return false;
        }
        const digits = sid.substr(1);
        return parseInt(digits, 10).toString(10) === digits;
    },

    propType: createChainableTypeChecker((props, propName, componentName) => {
        if (ClientId.is(props[propName])) {
            return;
        }
        return new PropTypeError(`'${propName}' (supplied to ${componentName}) isn't a valid ClientId`);
    }),
};

export default ClientId;



// WEBPACK FOOTER //
// ./app/data/ClientId.js